import React, { useEffect } from 'react';
import { usePageHeader } from '../../contexts/PageHeaderContext';
import ProfileEdit from '../../components/v3/user/ProfileEdit';

const ProfilePage: React.FC = () => {
  const { setPageInfo } = usePageHeader();
  
  useEffect(() => {
    setPageInfo({
      title: 'Your Profile',
      description: 'View and edit your profile settings'
    });
  }, [setPageInfo]);
  
  return (
    <div className="container mx-auto max-w-6xl">
      <ProfileEdit />
    </div>
  );
};

export default ProfilePage;